import Button, {ButtonVariant} from 'bitmovin-web-ui/src/components/core/button';
import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';

import AccordionPanel from '../../components/accordionPanel';
import {Link, pxToEm} from '../../components/globalStyles';
import WrapperAppUl from '../../components/wrapperAppUl';
import {AppRoutePathFunction} from '../../logic/routes';
import {RootState} from '../../logic/store';
import {LoadingState, State as SalesDemosState} from '../../logic/store/salesDemosStore';

//#region Styled Components

const StyledWrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
`;

const StyledAccordionPanel = styled(AccordionPanel)`
  width: 100%;

  :not(:last-child) {
    margin-bottom: ${pxToEm(18)}em;
  }
`;

const StyledButton = styled(Button)`
  margin-top: 1em;
  margin-right: 1em;
`;

//#endregion

enum OnPremiseAnalyticsAccordionHeadline {
  Metrics = 'Metrics',
  DeviceInformation = 'Device Information',
  Integrations = 'Integrations'
}

interface MapStateToProps {
  salesDemos?: SalesDemosState;
}

interface Props extends MapStateToProps {
  className?: string;
}

interface State {
  expandedAccordionHeadlines: OnPremiseAnalyticsAccordionHeadline;
}

class OnPremiseAnalyticsAccordions extends React.Component<Props, State> {
  public state: Readonly<State> = {
    expandedAccordionHeadlines: undefined
  };

  private handleAccordionPanelExpand = (accordionHeadline: OnPremiseAnalyticsAccordionHeadline) => {
    const isAlreadyExpanded = this.state.expandedAccordionHeadlines === accordionHeadline;
    this.setState({
      expandedAccordionHeadlines: isAlreadyExpanded ? undefined : accordionHeadline
    });
  };

  public render() {
    return (
      <StyledWrapperDiv className={this.props.className}>
        <StyledAccordionPanel
          headline={OnPremiseAnalyticsAccordionHeadline.Metrics}
          expanded={this.state.expandedAccordionHeadlines === OnPremiseAnalyticsAccordionHeadline.Metrics}
          onExpand={() => this.handleAccordionPanelExpand(OnPremiseAnalyticsAccordionHeadline.Metrics)}>
          <WrapperAppUl>
            <li>Impressions & users</li>
            <li>Content engagement</li>
            <li>Re-buffering</li>
            <li>Startup delay</li>
            <li>Player load time</li>
            <li>Errors & warnings</li>
            <li>Scale factor</li>
          </WrapperAppUl>
        </StyledAccordionPanel>

        <StyledAccordionPanel
          headline={OnPremiseAnalyticsAccordionHeadline.DeviceInformation}
          expanded={this.state.expandedAccordionHeadlines === OnPremiseAnalyticsAccordionHeadline.DeviceInformation}
          onExpand={() => this.handleAccordionPanelExpand(OnPremiseAnalyticsAccordionHeadline.DeviceInformation)}>
          <WrapperAppUl>
            <li>Browser</li>
            <li>Operating system</li>
            <li>Device type</li>
            <li>Screen dimensions</li>
            <li>Language</li>
            <li>Geolocation</li>
          </WrapperAppUl>
        </StyledAccordionPanel>

        <StyledAccordionPanel
          headline={OnPremiseAnalyticsAccordionHeadline.Integrations}
          expanded={this.state.expandedAccordionHeadlines === OnPremiseAnalyticsAccordionHeadline.Integrations}
          onExpand={() => this.handleAccordionPanelExpand(OnPremiseAnalyticsAccordionHeadline.Integrations)}>
          <WrapperAppUl>
            <li>Bitmovin Video Player</li>
            <li>iOS & Android SDKs</li>
            <li>HLS.js</li>
            <li>Video.js</li>
            <li>Shaka</li>
            <li>DASH.js</li>
          </WrapperAppUl>
        </StyledAccordionPanel>
      </StyledWrapperDiv>
    );
  }

  public renderDemoLinkButton = (demoPath: string) => {
    const {loadingState, response} = this.props.salesDemos;

    if (loadingState !== LoadingState.Success) {
      return null;
    }

    const allLoadedDemos = response.demos || [];
    const foundDemo = allLoadedDemos.find(salesDemo => salesDemo.path === demoPath);
    if (foundDemo === undefined) {
      return null;
    }

    return (
      <Link to={AppRoutePathFunction.DemoDetail({demoId: foundDemo.id})}>
        <StyledButton variant={ButtonVariant.OutlinedLight}>{foundDemo.name}&nbsp;Demo</StyledButton>
      </Link>
    );
  };
}

const mapStateToProps = (state: RootState): MapStateToProps => ({
  salesDemos: state.salesDemos
});

export default connect(mapStateToProps)(OnPremiseAnalyticsAccordions);
